export default function Hero() {
  const scrollToGame = () => {
    const element = document.getElementById('game');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/ab76238d4d3c54ff07890ac58caf11d1.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-amber-900/50 via-orange-800/40 to-amber-900/50"></div>
      </div>

      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto w-full">
        <div className="mb-8 flex justify-center">
          <div className="bg-gradient-to-br from-amber-400 to-orange-500 rounded-full p-6 shadow-2xl">
            <i className="ri-gift-2-fill text-7xl text-white"></i>
          </div>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 drop-shadow-lg">
          Пройди Опрос
        </h1>
        
        <p className="text-xl md:text-2xl text-white/95 mb-4 drop-shadow-md">
          Получи 50 000 бьютисов в подарок!
        </p>
        
        <p className="text-lg md:text-xl text-white/90 mb-12 max-w-3xl mx-auto drop-shadow-md">
          Поделись своим мнением о работе Золотого Яблока и получи гарантированную награду в 50 000 бьютисов. Твоё мнение важно для нас!
        </p>
        
        <button 
          onClick={scrollToGame}
          className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-10 py-4 rounded-full text-lg font-semibold hover:from-amber-600 hover:to-orange-600 transition-all duration-300 shadow-2xl hover:shadow-amber-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          Начать Опрос
        </button>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-white/80"></i>
      </div>
    </section>
  );
}
